'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var utils = require('../utils');
var IconSpin = _interopDefault(require('../icon-spin'));
var getSystem = require('@mx/util/get-system');

var duration = 300;
var system = getSystem.getSystem();
var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "pull-refresh",
      style: _vm.style,
      on: {
        "touchstart": _vm.onTouchStart,
        "touchmove": _vm.onTouchMove,
        "touchend": _vm.onTouchEnd,
        "touchcalcel": _vm.onTouchEnd
      }
    }, [_c('div', {
      ref: "head",
      staticClass: "pull-refresh-head"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.status === 'pulling',
        expression: "status === 'pulling'"
      }],
      staticClass: "pull-refresh-text"
    }, [_vm._v("下拉即可刷新...")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.status === 'loosing',
        expression: "status === 'loosing'"
      }],
      staticClass: "pull-refresh-text"
    }, [_vm._v("释放即可刷新...")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.status === 'loading',
        expression: "status === 'loading'"
      }],
      staticClass: "pull-refresh-loading"
    }, [_c('icon-spin'), _vm._v(" "), _c('span', [_vm._v("加载中...")])], 1)]), _vm._v(" "), _vm._t("default")], 2);
  },
  staticRenderFns: [],
  name: 'pull-refresh',
  components: {
    IconSpin: IconSpin
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    scrollBox: {
      default: function _default() {
        if (system === 'node') {
          return {};
        } else {
          return document.body;
        }
      }
    }
  },
  data: function data() {
    return {
      status: 'normal',
      height: 0,
      duration: 0,
      ceiling: false,
      startX: 0,
      startY: 0,
      deltaY: 0,
      direction: ''
    };
  },
  computed: {
    style: function style() {
      return {
        transition: "".concat(this.duration, "ms"),
        transform: "translate(0,".concat(this.height, "px)")
      };
    },
    headHeight: function headHeight() {
      var head = this.$refs.head;
      return head.offsetHeight;
    }
  },
  methods: {
    watchValue: function watchValue() {
      if (!this.value) {
        this.duration = duration;
        this.getStatus(0);
      } else {
        this.getStatus(this.headHeight, true);
      }
    },
    onTouchStart: function onTouchStart(event) {
      if (this.status === 'loading') {
        return;
      }

      if (this.getCeiling()) {
        this.duration = 0;
        this.startX = event.touches[0].clientX;
        this.startY = event.touches[0].clientY;
      }
    },
    onTouchMove: function onTouchMove(event) {
      if (this.status === 'loading') {
        return;
      }

      this.deltaY = event.touches[0].clientY - this.startY;
      this.direction = this.getDirection(event.touches[0]);

      if (!this.ceiling && this.getCeiling()) {
        this.duration = 0;
        this.startY = event.touches[0].clientY;
        this.deltaY = 0;
      }

      if (this.ceiling && this.deltaY >= 0) {
        if (this.direction === 'vertical') {
          event.preventDefault();
          this.getStatus(this.ease(this.deltaY));
        }
      }
    },
    onTouchEnd: function onTouchEnd() {
      if (this.status === 'loading') {
        return;
      }

      if (this.ceiling && this.deltaY) {
        this.duration = duration;

        if (this.status === 'loosing') {
          this.getStatus(this.headHeight, true);
          this.$emit('input', true);
        } else {
          this.getStatus(0);
        }
      }
    },
    getCeiling: function getCeiling() {
      var scrollBox = this.scrollBox;
      var scrollTop = scrollBox.hasOwnProperty('pageYOffset') ? window.pageYOffset || window.scrollY : scrollBox.scrollTop;
      return this.ceiling = scrollTop === 0;
    },
    ease: function ease(height) {
      return height < this.headHeight ? height : height < this.headHeight * 2 ? Math.round(this.headHeight + (height - this.headHeight) / 2) : Math.round(this.headHeight * 1.5 + (height - this.headHeight * 2) / 4);
    },
    getStatus: function getStatus(height, isLoading) {
      this.height = height;
      var status = isLoading ? 'loading' : height === 0 ? 'normal' : height < this.headHeight ? 'pulling' : 'loosing';

      if (status !== this.status) {
        this.status = status;
      }
    },
    getDirection: function getDirection(touch) {
      var distanceX = Math.abs(touch.clientX - this.startX);
      var distanceY = Math.abs(touch.clientY - this.startY);
      return distanceX > distanceY ? 'horizontal' : distanceX < distanceY ? 'vertical' : '';
    }
  },
  watch: {
    value: function value() {
      this.watchValue();
    }
  }
});

exports.default = index;
